import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
const crops = [
  // List of crops (same as in your provided JavaScript code)
  { name: "Wheat", constant: 14.7 },
    { name: "Maize", constant: 14.7 },
    { name: "Sorghum", constant: 14.7 },
    { name: "Bajra", constant: 14.7 },
    { name: "Barley", constant: 14.7 },
    { name: "Oats", constant: 14.7 },
    { name: "Paddy_(not_shelled_rice)", constant: 14.7 },
    { name: "Mash", constant: 14.7 },
    { name: "Moong", constant: 14.7 },
    { name: "Lentil", constant: 14.7 },
    { name: "Arhar", constant: 14.7 },
    { name: "Peas", constant: 14.7 },
    { name: "Soybean", constant: 25.0 },
    { name: "Sesame", constant: 25.0 },
    { name: "Rape seed", constant: 25.0 },
    { name: "Mustard", constant: 25.0 },
    { name: "Linseed", constant: 25.0 },
    { name: "Sunflower", constant: 25.0 },
    { name: "Sugarcane", constant: 5.3 },
    { name: "Sweet_potato", constant: 5.6 },
    { name: "Tapioca", constant: 5.6 },
    { name: "Potato", constant: 3.6 },
    { name: "Beet_root", constant: 3.6 },
    { name: "Colacasia", constant: 3.6 },
    { name: "Broad_beans", constant: 1.9 },
    { name: "Clusterbeans", constant: 1.9 },
    { name: "Ladyfinger", constant: 1.9 },
    { name: "Muskmelon", constant: 1.9 },
    { name: "Watermelon", constant: 1.9 },
    { name: "Cucumber_family", constant: 0.8 },
    { name: "Drumstick_giant", constant: 0.8 },
    { name: "Green_papaya", constant: 0.8 },
    { name: "Pumpkin", constant: 0.8 },
    { name: "Tomato", constant: 0.8 },
    { name: "Chillies", constant: 0.8 },
    { name: "Cabbage", constant: 0.8 },
    { name: "Spinach", constant: 0.8 },
    { name: "Green_mustard_leaves", constant: 0.8 },
    { name: "Cotton", constant: 11.8 },
    { name: "Sunnhemp", constant: 11.8 },
    { name: "Jute", constant: 11.8 },
    { name: "Berseem", constant: 18.0 },
    { name: "Lucerne", constant: 18.0 },
    { name: "Senji", constant: 18.0 },
    { name: "Cowpea", constant: 18.0 },
    { name: "Guara", constant: 18.0 },
    { name: "Napier", constant: 18.0 },
    { name: "Tamarind", constant: 18.0 },
    { name: "Grapes", constant: 18.0 },
    { name: "Guava", constant: 18.0 },
    { name: "Mango", constant: 11.8 },
    { name: "Amla", constant: 11.8 },
    { name: "Apple", constant: 1.9 },
    { name: "Peach", constant: 1.9 },
    { name: "Pears", constant: 1.9 },
    { name: "Pineapples", constant: 1.9 },
    { name: "Ber", constant: 1.9 },
    { name: "Sapotta", constant: 1.9 },
    { name: "Cashew", constant: 1.9 },
    { name: "Citrus", constant: 1.9 }
];

function Navbar() {
  const navigate = useNavigate();
  const [suggestions, setSuggestions] = useState([]);
  const [selectedSuggestionIndex, setSelectedSuggestionIndex] = useState(-1);
  const inputRef = useRef(null);

  // Close suggestion list when clicked outside the input or suggestion list
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setSuggestions([]);
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  const handleInputChange = (event) => {
    const searchText = event.target.value.toLowerCase();

    // If the search text is empty, do not show any suggestions
    if (searchText === '') {
      setSuggestions([]);
      return;
    }

    // Filter crops based on the search text
    const filteredSuggestions = crops.filter((crop) =>
      crop.name.toLowerCase().startsWith(searchText)
    );

    setSuggestions(filteredSuggestions);
    setSelectedSuggestionIndex(-1);
  };

  const handleSuggestionClick = (crop) => {
    // Handle suggestion click here (e.g., perform some action with the selected crop)
    console.log("Selected Crop:", crop);
    navigate(`/table/${crop.name}`);
    setSuggestions([]); // Collapse the suggestion list after selecting a crop
  };

  const handleFormSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission
    const searchText = event.target.elements.search.value.toLowerCase();
    const matchingCrop = crops.find((crop) => crop.name.toLowerCase() === searchText);
    if (matchingCrop) {
      navigate(`/table/${matchingCrop.name}`);
      setSuggestions([]); // Collapse the suggestion list after successful search
    }
  };

  const handleDownloadPDF = () => {
    // Create an anchor element to trigger the download
    const link = document.createElement('a');
    link.href = 'https://rewardiiswc.in/reactapp/user_manual.pdf'; // Replace with the actual path to the User Manual PDF
    link.download = 'user_manual.pdf'; // The name to be used when downloading
  
    // Add event listener for when the download is complete
    link.addEventListener('click', () => {
      // Clean up: remove the anchor from the document
      document.body.removeChild(link);
    });
  
    // Add the anchor to the document body
    document.body.appendChild(link);
  
    // Simulate a click on the anchor to trigger the download
    link.click();
  };
  

  return (
    <div className="position-relative">
      <nav className="navbar bg-body-tertiary">
        <div className="container-fluid">
          <p className="navbar-brand"> Energy Efficiency Calculator for Crops</p>
          <Link to="https://rewardiiswc.in/reactapp/index.html" className='navbar-home'>
          HOME
        </Link>
        <div className="dropdown">
        <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
          HELP
        </button>
        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          {/* Add an onClick handler for the "User Manual" item */}
          <li><a className="dropdown-item" href="#" onClick={handleDownloadPDF}>User Manual</a></li>
          {/* <li><a className="dropdown-item" href="#">Another action</a></li>
          <li><a className="dropdown-item" href="#">Something else here</a></li> */}
        </ul>
      </div>
          <form className="d-flex" role="search" ref={inputRef} onSubmit={handleFormSubmit}>
            <input
              className="form-control me-2"
              type="search"
              placeholder="Search"
              aria-label="Search"
              name="search" // Add a name to the input field for form submission
              onChange={handleInputChange}
            />
            <button className="btn btn-outline-success" type="submit">
              Search
            </button>
          </form>
        </div>
      </nav>
      {suggestions.length > 0 && (
        <ul className="suggestions-list">
          {suggestions.map((crop, index) => (
            // Wrap each suggestion in a Link component with the appropriate URL for the crop
            <Link
              key={crop.name}
              to={`/table/${crop.name}`} // Assuming the crop name is unique and can be used in the URL
              className={index === selectedSuggestionIndex ? "selected" : ""}
              onClick={() => handleSuggestionClick(crop)}
            >
              <li>{crop.name}</li>
            </Link>
          ))}
        </ul>
      )}
    </div>
  );
}

export default Navbar;